import Alerts from "./Alerts.js"

export default Alerts
